// Generated by ts-to-zod
import { z } from 'zod';
import { relationBaseSchema } from '../models/relations.schema';

export const patchRelationPayloadSchema = relationBaseSchema.partial();
